import { ObjectIdSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const NetSuiteUpdateSalesOrderRequestSchema = oz.object({
  contractId: ObjectIdSchema,
  productsIds: oz.array(ObjectIdSchema),
  subsidiaryId: oz.string(),
}).openapi('netSuiteUpdateSalesOrderRequest');

export type NetSuiteUpdateSalesOrderRequestPayload = oz.infer<typeof NetSuiteUpdateSalesOrderRequestSchema>;